import React from 'react';
import { ReactComponent as ArrowIcon } from './../assets/icons/ArrowIcon.svg';

const ButtonContent = ({ title }) => (
  <>
    <span>{title}</span>
    <div className="relative w-5 h-5 ml-1 overflow-hidden">
      <div className="absolute transition-all duration-200 group-hover:-translate-y-5 group-hover:translate-x-4">
        <ArrowIcon className="w-5 h-5" />
        <ArrowIcon className="w-5 h-5 -translate-x-4" />
      </div>
    </div>
  </>
);

const ButtonUnderlineAnimation = ({ title, setUnderline }) => (
  <>
    {!setUnderline ? (
      <div className="flex pb-1 bg-left-bottom bg-gradient-to-r from-neutral-700 to-neutral-700 bg-[length:0%_2px] bg-no-repeat group-hover:bg-[length:100%_2px] transition-all duration-500 ease-out">
        <ButtonContent title={title} />
      </div>
    ) : (
      <ButtonContent title={title} />
    )}
  </>
);

const ExternalLink = ({ title, href, isUnderline }) => {
  return (
    <>
      {href ? (
        <button className="relative items-center justify-center font-semibold outline-none text-neutral-200 hover:text-black group">
          <a
            href={href}
            className="flex transition-all duration-300 ease-in-out group"
          >
            <ButtonUnderlineAnimation
              title={title}
              setUnderline={isUnderline}
            />
          </a>
        </button>
      ) : (
        <div className="relative items-center justify-center font-medium outline-none hover:text-black group">
          <div className="flex transition-all duration-300 ease-in-out group">
            <ButtonUnderlineAnimation
              title={title}
              setUnderline={isUnderline}
            />
          </div>
        </div>
      )}
    </>
  );
};
export default ExternalLink;
